<template>
    <v-list-item>
      <v-list-item-avatar tile class="grey" size="40" style="align-self: end">
        <v-icon>mdi-laptop</v-icon>
      </v-list-item-avatar>
      <v-list-item-content class="py-0 mb-2">
        <h3 class="title font-weight-regular text-truncate">{{job.job}}</h3>
        <h4 class="subtitle-1 font-weight-regular">{{job.company.name}}</h4>
        <h5 class="subtitle-2" v-if="job.period">{{job.period}}</h5>
        <h5 class="subtitle-2" v-if="job.location">{{job.location}}</h5>
        <show-more-less v-if="job.description" :text="job.description" :max-length="350"></show-more-less>
      </v-list-item-content>
    </v-list-item>
</template>

<script>
  import ShowMoreLess from "../../Widgets/showMoreLess";

  export default {
    name: "singleJobMocker",
    components: {ShowMoreLess},
    props: ['delta', 'job']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mockers/Lin/singleJobMocker.vue